import { defineContext } from '@/utils/vue/context';
import { ref } from '@vue/composition-api';
export const [provideAIEditorContext, mountAIEditorContext, getAIEditorContext] = defineContext(() => ({ ready: ref(false) }));
